import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpError } from 'app/helpers/httpError';
import { HttpRequestHelper } from 'app/helpers/httpRequestHelper';
import { ExposedCreateApplicationsManualStatisticsReq } from 'app/interfaces/requests/Exposed/exposedCreateApplicationsManualStatisticsReq';
import { ExposedDeleteApplicationsManualStatisticsReq } from 'app/interfaces/requests/Exposed/exposedDeleteApplicationsManualStatisticsReq';
import { ExposedListApplicationsManualStatisticsReq } from 'app/interfaces/requests/Exposed/exposedListApplicationsManualStatisticsReq';
import { ExposedListApplicationTypesManualStatisticsRes } from 'app/interfaces/responses/Exposed/exposedListApplicationTypesManualStatisticsRes';
import { ExposedListApplicationsManualStatisticsRes } from 'app/interfaces/responses/Exposed/exposedListApplicationsManualStatisticsRes';
import { HttpStatus } from 'app/interfaces/support/status/httpStatus';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { LoaderService } from 'app/services/system/loader/loader.service';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ApplicationsService {
    private httpRequestHelper = new HttpRequestHelper();

    constructor(
        private http: HttpClient,
        private loaderService: LoaderService,
        private alertsService: AlertsService,
        private router: Router,
        public dialog: MatDialog
    ) {}

    public listManualStatisticsTypes(showError = true): Observable<Array<ExposedListApplicationTypesManualStatisticsRes>> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki upplýsingar');

        const subject = new Subject<Array<ExposedListApplicationTypesManualStatisticsRes>>();
        this.http
            .get(
                environment.localApi + 'applicationsManualStatistics/manualStatisticsTypes/list',
                this.httpRequestHelper.getRequestOptionsAuth()
            )
            .subscribe(
                (res: HttpStatus<Array<ExposedListApplicationTypesManualStatisticsRes>>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public listManualStatistics(
        req: ExposedListApplicationsManualStatisticsReq,
        showError = true
    ): Observable<Array<ExposedListApplicationsManualStatisticsRes>> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Sæki tölfræði');

        const subject = new Subject<Array<ExposedListApplicationsManualStatisticsRes>>();
        this.http
            .post(
                environment.localApi + 'applicationsManualStatistics/manualStatistics/list',
                req,
                this.httpRequestHelper.getRequestOptionsAuth()
            )
            .subscribe(
                (res: HttpStatus<Array<ExposedListApplicationsManualStatisticsRes>>) => {
                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public deleteManualStatistic(req: ExposedDeleteApplicationsManualStatisticsReq, showError = true): Observable<number> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Eyði færslu');

        const subject = new Subject<number>();
        this.http
            .post(
                environment.localApi + 'applicationsManualStatistics/manualStatistics/delete',
                req,
                this.httpRequestHelper.getRequestOptionsAuth()
            )
            .subscribe(
                (res: HttpStatus<number>) => {
                    this.alertsService.changeAlertShowIcon(true);
                    this.alertsService.changeAlertSuccessMessage('Færslu hefur verið eytt');
                    this.alertsService.changeAlertSuccessShow(true);

                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }

    public addManualStatistic(req: ExposedCreateApplicationsManualStatisticsReq, showError = true): Observable<number> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Skrái færslu');

        const subject = new Subject<number>();
        this.http
            .post(
                environment.localApi + 'applicationsManualStatistics/manualStatistics/add',
                req,
                this.httpRequestHelper.getRequestOptionsAuth()
            )
            .subscribe(
                (res: HttpStatus<number>) => {
                    this.alertsService.changeAlertShowIcon(true);
                    this.alertsService.changeAlertSuccessMessage('Færsla hefur verið skráð');
                    this.alertsService.changeAlertSuccessShow(true);

                    subject.next(res.returnItem);
                },
                (error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }
                }
            )
            .add(() => {
                this.loaderService.changeActiveLoaders(-1);
            });
        return subject.asObservable();
    }
}
